<template>
  <div class="home">
    <!--<v-row align="center">
      <v-spacer />
      <v-col>
        <v-btn
          v-if="!isAuthenticated"
          outlined
          color="#C1563E"
          :to="{ name: 'LoginSignupRoute' }"
        >
          Login to start
        </v-btn>
      </v-col>
    </v-row>-->

    <v-row v-if="isAuthenticated">
      <v-col>
        <div class="text-center">
          <p class="mb-2">Logged in as {{ user.full_name }} ({{ user.email }})</p>
          <small><a href="#" @click.prevent="logout">Is this not you?</a></small>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <p>Join Ra Yoga’s 4th annual March Yoga Challenge for a chance to win on so many levels!</p>

        <p>A consistent yoga practice can teach us so much about our physical abilities and our mental resilience.  Commit to your yoga practice for the month to see how your body and mind can truly transform!</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="mb-5">
        <v-btn
          block
          x-large
          color="#540811"
          dark
          depressed
          v-if="!isAuthenticated"
          :to="{ name: 'LoginSignupRoute' }">
          Login to start challenge
        </v-btn>
        <v-btn
          block
          x-large
          color="#540811"
          dark
          depressed
          v-if="isAuthenticated"
          @click="openConfirmDialog">
          Join the challenge
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="mb-5">
        <div class="rounded-card tan">
          <h2 class="text-center mb-5">Yoga Challenge FAQs</h2>
          <h3 class="mb-1"><strong>What if I can’t complete 30 classes?</strong></h3>
          <p>That’s okay! It’s all about devotion to your practice. Even if you get to 15 classes you earn a chance to win.</p>
          <br />
          <h3 class="mb-1"><strong>Can I join the challenge if I’m not a member?</strong></h3>
          <p>Yes! Email <a href="mailto:info@rayoga.com">info@rayoga.com</a> for a contract-free, unlimited month of yoga for $149.</p>
          <br />
          <h3 class="mb-1"><strong>What does it cost to join?</strong></h3>
          <p>It is free to join. You just need valid class credits / membership to attend classes.</p>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="text-center">
        <h3>Complete the 30-Day Challenge and you’ll be entered into a raffle to win...</h3>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="prize-container">
        <ul class="prize-list">
          <li>1 Month Unlimited Yoga</li>
          <li>$50 Retail Credit</li>
          <li>1 Year of Ra Yoga Live</li>
        </ul>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <p>There’s an easy way to earn extra raffle entries to increase your chances of winning! Learn more after signing up!</p>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="mb-5">
        <v-btn
          block
          x-large
          color="#540811"
          dark
          depressed
          v-if="!isAuthenticated"
          :to="{ name: 'LoginSignupRoute' }">
          Login to start challenge
        </v-btn>
        <v-btn
          block
          x-large
          color="#540811"
          dark
          depressed
          v-if="isAuthenticated"
          @click="openConfirmDialog">
          Join the challenge
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="mb-5">
        <div class="rounded-card greenn py-10">
          <h2 class="text-center mb-5"><em>“Be open to trying all classes that RA offers. You never know you can do and what your body needs.”</em></h2>
          <p class="text-right">2024 Challenge Participant when asked what advice they'd give themselves on Day 1</p>
        </div>
      </v-col>
    </v-row>

    <!--<v-row justify="center">
      <v-col cols="12" class="mb-5">
        <div class="white-block pa-10">
          <v-row justify="center">
            <img style="min-width: 80%;" class="mb-8" src="../assets/sun.svg">
            <h2 class="text-center mb-3">Want to join the challenge, but need a membership?</h2>
            <p style="font-size: 12px;" class="mb-7">For a limited time, you can signup for a one-month unlimited membership for $149.99. Here are some more details: No contract required. This membership must be purchased by March 5th and expires on April 5th, 2025.</p>
            <v-btn
              block
              x-large
              color="#540811"
              dark
              depressed
              href="https://landing.rayoga.com/?promo_id=55"
              target="_BLANK">
              Buy Challenge Membership
            </v-btn>
          </v-row>
        </div>
      </v-col>
    </v-row>-->

    <v-dialog
      v-model="confirmDialog"
      closable
      max-width="480"
      >
      <v-card class="confirm-dialog pa-8">
        <v-card-text>
          <h1 class="text-center mb-4">Let's Go!</h1>
          <p>A few things to note before joining the challenge.</p>
          <ul>
            <li>You will use your regular pricing options to book classes.</li>
            <li>The challenge has no cost associated with it.</li>
            <li>No penalty for not completing the challenge.</li>
            <li>Special present for anyone who gets to 15 classes.</li>
            <li>Must attend 30 classes in March 2026 to be eligible for raffle.</li>
            <li>The more people you get to participate with you, the more raffle entries you receive!</li>
          </ul>
          <v-checkbox v-model="confirmCheckbox" color="#ffffff" label="I understand that by participating in this challenge, my photos, videos, and text may be used for positive, promotional purposes."></v-checkbox>
          <v-col class="text-center">
            <v-btn
              color="#EFA83C"
              dark
              depressed
              @click="createChallengeSignup"
              :disabled="isConfirmPending || !confirmCheckbox"
              x-large>
              Confirm
            </v-btn>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// @ is an alias to /src

export default {
  name: 'Home',

  data() {
    return {
      confirmDialog: false,
      confirmCheckbox: false,
      isConfirmPending: false,
    }
  },

  components: {
  },

  computed: {
    ...mapGetters([
      'isAuthenticated',
      'hasSignedUp'
    ]),
    user() {
      return this.$store.state.user
    },
  },

  methods: {
    openConfirmDialog() {
      this.confirmDialog = true
    },
    async createChallengeSignup() {
      this.isConfirmPending = true
      await this.$store.dispatch('createChallengeSignup', {
        challengeId: this.$store.state.challengeId,
        customerId: this.user.id,
        customerName: this.user.full_name,
        customerEmail: this.user.email,
        referral: this.$store.state.ref,
      })
      this.confirmDialog = false
      this.isConfirmPending = false

      this.$router.push('/challenge')
    },
    logout() {
      window.localStorage.removeItem('vuex')
      window.location.href = 'https://challenge.rayoga.com?prompt=1'
    },
  },

  mounted() {
    console.log(this.$route.query)
    if (this.$route.query.ref) {
      this.$store.state.ref = this.$route.query.ref
    }

    if (this.$route.query.prompt) {
      this.$store.state.prompt = true
    }

    if (this.hasSignedUp) {
      this.$router.push('/challenge')
    }
  }
}
</script>

<style lang="scss">
.white-block {
  background-color: #ffffff;
  border-radius: 13px;
  box-shadow: 0px 2px 6px rgba(0,0,0,0.2);
}

.prize-container {
  text-align: left;

  .prize-header {
    font-size: 20px;
    font-weight: 900;
  }

  .prize-list {
    font-size: 14px;
    list-style-position: inside;
    list-style: none;
    padding-left: 110px;

    li {
      background-image: url('~@/assets/prize-icon.svg');
      background-repeat: no-repeat;
      padding-left: 20px;
      padding-bottom: 5px;
    }
  }

  p {
    font-size: 14px;
  }
}

.rounded-card {
  background-color: #ffffff;
  border-radius: 8px;
  padding: 20px 30px;

  h3 {
    font-weight: 800;
    margin-bottom: 15px;
  }

  p {
    font-size: 14px;
    margin-bottom: 10px;
  }
}

.rounded-card.tan {
  background-color: #CEAD88;
  color: #184B28;
}

.rounded-card.greenn {
  background-color: #184B28;
  color: #ffffff;
}

.confirm-dialog {
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #3F523E !important;
  background-size: cover;
  border-radius: 8px;
  color: #ffffff !important;
  font-size: 16px;
  font-weight: 100 !important;

  ul {
    list-style: none;
    li {
      background-image: url('~@/assets/arrow.svg');
      background-position-y: 13px;
      padding-left: 30px;
      margin-bottom: 10px;
    }
  }

  &.theme--light.v-card > .v-card__text,
  .v-label.theme--light {
    color: #ffffff !important;
  }

  .theme--light.v-card > .v-card__text,
  .theme--light.v-input {
    color: #ffffff !important;
  }
}

@media(max-width: 500px) {
  .prize-container {
    .prize-list {
      padding-left: 20px;
    }
  }
}
</style>
